export type MakeSystemPrompt = (textareaPurpose: string, contextString: string) => string;
